import React, { useRef, useState, useEffect } from 'react';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import 'primeflex/primeflex.css';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { InputMask } from 'primereact/inputmask';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import '../layout/sass/_formEscola.scss'
import api from '../api/api';

export const FormPropriedade = ({ isEditing, isLoading, defaultValues }) => {

    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)
    const history = useHistory();

    const [municipios, setMunicipios] = useState(null);
    const [proprietario,setProprietarios]=useState(null);
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const pronaf = [{ value: true, label: "SIM" }, { value: false, label: "NÃO" }];

    const tipoPosse = [
        { value: "PRÓPRIO", label: "PRÓPRIO" },
        { value: "ARRENDADO", label: "ARRENDADO" },
        { value: "OUTRO", label: "OUTRO" }
    ];

    const schema = Yup.object().shape({
        nome: Yup
            .string()
            .required("O nome da propriedade é obrigatório")
            .max(200, "O nome deve ter no máximo 200 caracteres"),
        proprietarioId: Yup
            .number()
            .required("A pessoa é obrigatório")
            .positive("A pessoa deve ser selecionada")
            .integer("A pessoa deve estar na lista"),
        areaTotal: Yup
            .number()
            .required("Area é obrigatório")
            .moreThan(0, "Area tem que ser maior que 0"),        
        areaExplorada: Yup
            .number()
            .required("Area é obrigatório")
            .moreThan(0, "Area tem que ser maior que 0"),
        areaCultivada: Yup
            .number()
            .required("Area é obrigatório")
            .moreThan(0, "Area tem que ser maior que 0"),
        tipoPosse: Yup
            .string()
            .required("É obrigatório escolher o tipo de posse"),                                 
        municipioId:Yup 
            .number()
            .required("Município é obrigatório")
            .positive("O município deve ser selecionado")
            .integer("O município deve estar na lista")
    })

    const formik = useFormik({
        initialValues: defaultValues,

        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {

            setIsSubmiting(true)

            await api.post("propriedade", data)

            try {
                if (!isEditing) {

                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.nome} adicionado(a) com sucesso` });
                    setTimeout(() => {

                        history.push('/propriedade')

                    }, 2000)

                }
                else {

                    await api.put("propriedade", data)
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.nome} atualizado(a) com sucesso` });
                    setTimeout(() => {

                        history.push('/propriedade')

                    }, 2000)
                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar propriedade!', detail: error.response.data });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar propriedade!', detail: error.response.data });

            }

            setIsSubmiting(false)
        }
    })

    useEffect(() => {
        api.get("pessoa/tipo/1").then((response)=>setProprietarios(response.data));
        api.get("municipio/findAllBasic").then((response)=>setMunicipios(response.data));

    }, [])

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">
                    <h2 className="p-mt-0">Cadastro de Propriedade</h2>
                    <form onSubmit={formik.handleSubmit}>

                        <div className="p-formgrid p-grid p-fluid p-mx-0">
                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="proprietario"
                                    className={classNames({ 'p-error': isFormFieldValid('proprietario') })}
                                >
                                    Proprietário
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="proprietarioId"
                                            name="proprietarioId"
                                            options={proprietario}
                                            filter={true}
                                            emptyMessage={"Nenhum proprietário encontrado"}
                                            optionLabel="nome"
                                            optionValue="id"
                                            placeholder="Selecione um proprietário"
                                            className={classNames({ 'p-invalid': isFormFieldValid('proprietarioId') })}
                                            value={formik.values.proprietarioId}
                                            onChange={option => formik.setFieldValue("proprietarioId", option.value)}
                                            emptyFilterMessage={"Nenhum proprietário encontrado"}
                                            disabled={proprietario === ''}

                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.proprietarioId && formik.touched.proprietarioId &&
                                    <ErrorValidationMessage message={formik.errors.proprietarioId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="nome"
                                    className={classNames({ 'p-error': isFormFieldValid('nome') })}
                                >
                                    Nome da Propriedade
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="nome"
                                            name="nome"
                                            className={classNames({ 'p-invalid': isFormFieldValid('nome') })}
                                            value={formik.values.nome}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.nome && formik.touched.nome &&
                                    <ErrorValidationMessage message={formik.errors.nome} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="Endereço"
                                    className={classNames({ 'p-error': isFormFieldValid('endereco') })}
                                >
                                    Endereço
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="endereco"
                                            name="endereco"
                                            className={classNames({ 'p-invalid': isFormFieldValid('endereco') })}
                                            value={formik.values.endereco}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.endereco && formik.touched.endereco &&
                                    <ErrorValidationMessage message={formik.errors.endereco} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="Numero"
                                    className={classNames({ 'p-error': isFormFieldValid('numero') })}
                                >
                                    Numero
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="numero"
                                            name="numero"
                                            className={classNames({ 'p-invalid': isFormFieldValid('numero') })}
                                            value={formik.values.numero}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.numero && formik.touched.numero &&
                                    <ErrorValidationMessage message={formik.errors.numero} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="Complemento"
                                    className={classNames({ 'p-error': isFormFieldValid('complemento') })}
                                >
                                    Complemento
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="complemento"
                                            name="complemento"
                                            className={classNames({ 'p-invalid': isFormFieldValid('complemento') })}
                                            value={formik.values.complemento}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.complemento && formik.touched.complemento &&
                                    <ErrorValidationMessage message={formik.errors.complemento} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="cep"
                                    className={classNames({ 'p-error': isFormFieldValid('cep') })}
                                >
                                    CEP:
                                </label>
                                {
                                    !isLoading ?
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <InputMask
                                            id="cep"
                                            nome="cep"
                                            mask="99999-999"
                                            unmask={true}
                                            value={formik.values.cep}
                                            onChange={formik.handleChange}
                                            className={classNames({ 'p-invalid': isFormFieldValid('cep') })}
                                        />
                                    </div>
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.cep && formik.touched.cep &&
                                    <ErrorValidationMessage message={formik.errors.cep} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="Municipio"
                                    className={classNames({ 'p-error': isFormFieldValid('municipio') })}
                                >
                                    Município
                                </label>
                                {
                                    !isLoading ?
                                    <Dropdown
                                        id="municipioId"
                                        name="municipioId"
                                        options={municipios}
                                        filter={true}
                                        emptyMessage={"Nenhum município encontrado"}
                                        optionLabel="nome"
                                        optionValue="id"
                                        placeholder="Selecione um município"
                                        className={classNames({ 'p-invalid': isFormFieldValid('municipioId') })}
                                        value={formik.values.municipioId}
                                        onChange={option => formik.setFieldValue("municipioId", option.value)}
                                        emptyFilterMessage={"Nenhum município encontrado"}
                                        disabled={municipios === ''}

                                />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.municipioId && formik.touched.municipioId &&
                                    <ErrorValidationMessage message={formik.errors.municipioId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="areaTotal"
                                    className={classNames({ 'p-error': isFormFieldValid('areaTotal') })}
                                >
                                    Area Total
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="areaTotal"
                                            name="areaTotal"
                                            className={classNames({ 'p-invalid': isFormFieldValid('areaTotal') })}
                                            value={formik.values.areaTotal}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.areaTotal && formik.touched.areaTotal &&
                                    <ErrorValidationMessage message={formik.errors.areaTotal} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="areaExplorada"
                                    className={classNames({ 'p-error': isFormFieldValid('areaExplorada') })}
                                >
                                    Area Explorada
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="areaExplorada"
                                            name="areaExplorada"
                                            className={classNames({ 'p-invalid': isFormFieldValid('areaExplorada') })}
                                            value={formik.values.areaExplorada}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.areaExplorada && formik.touched.areaExplorada &&
                                    <ErrorValidationMessage message={formik.errors.areaExplorada} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="areaCultivada"
                                    className={classNames({ 'p-error': isFormFieldValid('areaCultivada') })}
                                >
                                    Area Cultivada
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="areaCultivada"
                                            name="areaCultivada"
                                            className={classNames({ 'p-invalid': isFormFieldValid('areaCultivada') })}
                                            value={formik.values.areaCultivada}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.areaCultivada && formik.touched.areaCultivada &&
                                    <ErrorValidationMessage message={formik.errors.areaCultivada} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="geoLocalizacao"
                                    className={classNames({ 'p-error': isFormFieldValid('geoLocalizacao') })}
                                >
                                    Geo Localização
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="geoLocalizacao"
                                            name="geoLocalizacao"
                                            className={classNames({ 'p-invalid': isFormFieldValid('geoLocalizacao') })}
                                            value={formik.values.geoLocalizacao}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.geoLocalizacao && formik.touched.geoLocalizacao &&
                                    <ErrorValidationMessage message={formik.errors.geoLocalizacao} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="pronaf"
                                    className={classNames({ 'p-error': isFormFieldValid('pronaf') })}
                                >
                                    Pronaf
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="pronaf"
                                            name="pronaf"
                                            options={pronaf}
                                            //filter={true}
                                            emptyMessage={"Nenhum proprietário encontrado"}
                                            optionLabel="label"
                                            optionValue="value"
                                            placeholder="Tem Pronaf?"
                                            className={classNames({ 'p-invalid': isFormFieldValid('pronaf') })}
                                            value={formik.values.pronaf}
                                            onChange={option => formik.setFieldValue("pronaf", option.value)}
                                            emptyFilterMessage={"Nenhum proprietário encontrado"}
                                            disabled={pronaf === ''}

                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.pronaf && formik.touched.pronaf &&
                                    <ErrorValidationMessage message={formik.errors.pronaf} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="tipoPosse"
                                    className={classNames({ 'p-error': isFormFieldValid('tipoPosse') })}
                                >
                                    Tipo de Posse
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="tipoPosse"
                                            name="tipoPosse"
                                            options={tipoPosse}
                                            //filter={true}
                                            emptyMessage={"Tipo de posse não encontrada"}
                                            optionLabel="value"
                                            optionValue="value"
                                            placeholder="Escolha o tipo de posse"
                                            className={classNames({ 'p-invalid': isFormFieldValid('tipoPosse') })}
                                            value={formik.values.tipoPosse}
                                            onChange={option => formik.setFieldValue("tipoPosse", option.value)}
                                            emptyFilterMessage={"Nenhum proprietário encontrado"}
                                            disabled={tipoPosse === ''}

                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.tipoPosse && formik.touched.tipoPosse &&
                                    <ErrorValidationMessage message={formik.errors.tipoPosse} />
                                }
                            </div>

                        </div>

                        <div className="p-formgrid p-grid p-fluid p-mx-0">
                            <div className="p-col-12">
                                <label
                                    htmlFor="propriedade"
                                    className={classNames({ 'p-error': isFormFieldValid('propriedade') })}
                                >

                                </label>
                            </div>
                        </div>

                    </form>
                </div>
            </div>

            <div className="p-d-flex p-justify-center p-mt-4">
                {
                    !isLoading ?
                        <Button
                            label={isEditing ? 'Editar' : 'Cadastrar'}
                            type="button"
                            loading={isSubmiting}
                            onClick={formik.handleSubmit}
                            style={{ width: '250px' }}
                        />
                        :
                        <Skeleton height="35px" />
                }
            </div>
        </>
    );
}